import React, { useMemo } from "react";
import { snakeToCamel } from "utils/caseConvertor";
import {
  TextField,
  Dropdown,
  MultiselectDropdown,
  RadioButtonGroup,
} from "../../Components";

interface WeatherConditionProps {
  panel: any; // replace 'any' with the appropriate type for the 'panel' prop'
  editMode: boolean;
  formikProps: any;
  handleUpdateStatus: any;
}

const WeatherCondition: React.FC<WeatherConditionProps> = ({
  panel,
  editMode,
  formikProps,
  handleUpdateStatus,
}) => {
  const panelElements =
    panel.templateElements && panel.templateElements.length > 0
      ? panel.templateElements
      : panel.elements && panel.elements.length > 0
        ? panel.elements
        : [];

  const panelName = snakeToCamel(panel.name);

  const onChange = (eleName: string, value: any, name: string) => {
    formikProps.setFieldValue(eleName, value)
    handleUpdateStatus(name, panel.sectionId)
  }

  //   const newValue = useMemo(() => {
  //     return value instanceof Array ? value.map((val) => { return { value: val.value || val, label: val.label || val } }) : value ? value : ""
  //   }, [value])

  return (
    <>
      <div className="grid grid-cols-2 gap-4 mb-5">
        {panelElements.map((element: any, index: number) => {
          const {
            name,
            title,
            choices,
            fieldAs,
            rows,
            value,
            inputType,
            type,
            placeholder,
            isRequired = false,
            visible = true,
            choicesByUrl,
            colCount
          } = element;
          const eleName = [panelName, element.name].join(".");
          const error = formikProps.errors[panelName]?.[element.name];
          const touched = formikProps.touched[panelName]?.[name];

          if (visible === false || type === "html") {
            return;
          }

          switch (element.type) {
            case "radiogroup":
              return (
                <RadioButtonGroup
                  key={index}
                  label={title}
                  name={name}
                  editMode={editMode}
                  value={formikProps.values[panelName]?.[name]}
                  handleChange={(item: any) =>
                    onChange(eleName, item, name)
                  }
                  data={choices}
                  choicesByUrl={choicesByUrl}
                  required={isRequired}
                  error={error}
                  touched={touched}
                  columns={colCount}
                  panel={panel}
                  element={element}
                />
              );

            case "text":
              return (
                <TextField
                  key={index}
                  label={title}
                  type={inputType || type}
                  name={name}
                  value={formikProps.values[panelName]?.[name]}
                  handleChange={(value: any) =>
                    onChange(eleName, value, name)
                  }
                  handleBlur={() =>
                    formikProps.setFieldTouched(eleName, true, true)
                  }
                  fieldAs={fieldAs}
                  rows={rows}
                  editMode={editMode}
                  placeholder={placeholder || `Enter ${title}`}
                  required={isRequired}
                  error={error}
                  touched={touched}
                  panel={panel}
                  element={element}
                />
              );

            case "dropdown":
              return (
                <Dropdown
                  key={index}
                  label={title}
                  name={name}
                  choices={choices}
                  choicesByUrl={choicesByUrl}
                  value={formikProps.values[panelName]?.[name]}
                  handleChange={(item: any) =>
                    onChange(eleName, item, name)
                  }
                  handleBlur={() =>
                    formikProps.setFieldTouched(eleName, true, true)
                  }
                  editMode={editMode}
                  placeholder={placeholder || `Select ${title}`}
                  required={isRequired}
                  error={error}
                  touched={touched}
                  panel={panel}
                  element={element}
                />
              );

            case "tagbox":
              return (
                <MultiselectDropdown
                  name={name}
                  data={choices}
                  choicesByUrl={choicesByUrl}
                  label={title}
                  placeholder={placeholder || `Select ${title}`}
                  editMode={editMode}
                  value={formikProps.values[panelName]?.[name] ?? ""}
                  handleChange={(selectedOptions: any) => {
                    const selectedValues = selectedOptions.map(
                      (option: any) => option
                    );
                    onChange(eleName, selectedValues, name);
                  }}
                  handleBlur={() =>
                    formikProps.setFieldTouched(eleName, true, true)
                  }
                  required={isRequired}
                  error={error}
                  touched={touched}
                  panel={panel}
                  element={element}
                />
              );

            default:
              return null; // Or render a default component for unknown types
          }
        })}
      </div>
    </>
  );
};

export default WeatherCondition;
